import { render, staticRenderFns } from "./Cinematic.vue?vue&type=template&id=51624fec"
import script from "./Cinematic.vue?vue&type=script&lang=js"
export * from "./Cinematic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports